module.exports = "<p>\n  Coming Soon!\n</p>\n"